
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";


export default function VehicleSparepartsTable() {
    const navigate = useNavigate();

    const handleNavigate = (vehicleno) => {
        navigate(`/${vehicleno}`);


    };
    const data = [
        { id: 2, vehicleno: "Uber Vehicle", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
        { id: 3, vehicleno: "MH03AS3945", spareparts: "Side Mirror", warranty: "24", quantity: "1", amount: "$1200" },
        { id: 4, vehicleno: "MH04KL0921", spareparts: "Side Mirror", warranty: "45", quantity: "1", amount: "$1200" },
        { id: 1, vehicleno: "MH20ER4534", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
        { id: 1, vehicleno: "MH20ER4534", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
        { id: 1, vehicleno: "MH20ER4534", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
        { id: 1, vehicleno: "MH20ER4534", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
        { id: 1, vehicleno: "MH20ER4534", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
        { id: 1, vehicleno: "MH20ER4534", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
        { id: 1, vehicleno: "MH20ER4534", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
        { id: 1, vehicleno: "MH20ER4534", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
        { id: 1, vehicleno: "MH20ER4534", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
        { id: 5, vehicleno: "MH05MH5932", spareparts: "Side Mirror", warranty: "44", quantity: "5", amount: "$1200" },
        { id: 6, vehicleno: "MH06MJ4321", spareparts: "Side Mirror", warranty: "4", quantity: "1", amount: "$1200" },
        { id: 7, vehicleno: "MH07ND4567", spareparts: "Side Mirror", warranty: "5", quantity: "2", amount: "$1200" },
        { id: 8, vehicleno: "MH08KK4909", spareparts: "Side Mirror", warranty: "3", quantity: "2", amount: "$1200" },
        { id: 9, vehicleno: "MH11KL0008", spareparts: "Side Mirror", warranty: "11", quantity: "2", amount: "$1200" },
        { id: 10, vehicleno: "MH20UI3424", spareparts: "Side Mirror", warranty: "12", quantity: "2", amount: "$1200" },
        { id: 11, vehicleno: "MH20SQ9021", spareparts: "Seat Cover", warranty: "34", quantity: "2 ", amount: "$1200" },
        { id: 12, vehicleno: "MH23MK8245", spareparts: "Cluch Wire", warranty: "13", quantity: "2", amount: "$1200" },
        { id: 13, vehicleno: "MH24NF5321", spareparts: "Break Linear", warranty: "55", quantity: "4", amount: "$1200" },
        { id: 14, vehicleno: "MH22PQ4441", spareparts: "Engine Oil", warranty: "12", quantity: "2", amount: "$1200" },
        { id: 15, vehicleno: "MH12EE2323", spareparts: "Battery", warranty: "34", quantity: "5", amount: "$1200" },
        { id: 30, vehicleno: "MH11FG9090", spareparts: "Oil Seal", warranty: "6", quantity: "1", amount: "$1200" },
        { id: 17, vehicleno: "MH20UI1221", spareparts: "Speed Meter", warranty: "9", quantity: "1", amount: "$1200" },
        { id: 18, vehicleno: "MH20EE0890", spareparts: "Tyer", warranty: "22", quantity: "1", amount: "$1200" },
        { id: 19, vehicleno: "MH20SQ0987", spareparts: "Side Mirror", warranty: "21", quantity: "2", amount: "$1200" },
        { id: 20, vehicleno: "MH21XQ0087", spareparts: "Side Mirror", warranty: "21", quantity: "2", amount: "$1200" },


    ];


    return (
        <div className="vehicle-spareparts-container my-4">

            <div className="special-header panel-white-all bg-white d-flex justify-content-between align-items-center mb-2">
                <h4 className="mb-0 page-title">Vehicle Spareparts</h4>
                <div className="d-flex align-items-center gap-2">
                    <Link to="/accountant/createvehiclespareparts" type="button" className="btn custom-btn">Create Vehicle Spareparts</Link>

                    <div className="dropdown position-relative">
                        <button id="btnGroupDropExport" type="button" className="btn custom-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            Export
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="btnGroupDropExport">
                            <li><a className="dropdown-item" href="#">Save as PDF</a></li>
                            <li><a className="dropdown-item" href="#">Save as PNG</a></li>
                            <li><a className="dropdown-item" href="#">Save as CSV</a></li>
                            <li><a className="dropdown-item" href="#">Save as TXT</a></li>
                            <li><a className="dropdown-item" href="#">Save as XML</a></li>
                            <li><a className="dropdown-item" href="#">Save as SQL</a></li>
                        </ul>
                    </div>
                </div>
            </div>
                   <div className="table-top-filters d-flex flex-wrap gap-3">

                                <select className="form-select form-control-sm dropdrown-iteam" style={{ maxWidth: "200px" }}>
                                    <option className="vehicle-dropdown">All</option>
                                    <option className="vehicle-dropdown">MH20EE3948</option>
                                    <option className="vehicle-dropdown">MH21RE4890</option>
                                </select>
                           
                                <input type="text" className="form-control form-control-sm" placeholder="SpareParts" style={{ maxWidth: "200px" }}/>
                        
                             <button type="button" class="btn custom-btn">Clear</button>
                            

                   </div>

            <div className="card-body">

                <div className="table-responsive">
                    <table className="custom-table" style={{marginTop:'-1px'}}>
                        <thead>
                           
                            <tr>
                                <th style={{textAlign:'center'}}>Sr No</th>
                                <th style={{textAlign:'center'}}>Vehicle Number/Name</th>
                                <th style={{textAlign:'center'}}>Spareparts</th>
                                <th style={{textAlign:'center'}}>Warranty</th>
                                <th style={{textAlign:'center'}}>Quantity</th>
                                <th style={{textAlign:'center'}}>Amount</th>
                                <th>Action</th>
                               </tr>

                        </thead>
                        <tbody>
                            {data.map((row) => (
                                <tr key={row.id}>
                                    <td style={{textAlign:'center'}}>{row.id}</td>
                                    <td style={{textAlign:'center'}}>{row.vehicleno}</td>
                                    <td style={{textAlign:'center'}}>{row.spareparts}</td>
                                    <td style={{textAlign:'center'}}>{row.warranty}</td>
                                    <td style={{textAlign:'center'}}>{row.quantity}</td>
                                    <td style={{textAlign:'center'}}>{row.amount}</td>
                                    <td>
                                        <div className="btn-group">
                                            <button
                                                type="button"
                                                className="btn  btn-sm"
                                                onClick={() => handleNavigate(row.vehicleno)}
                                                title="View">
                                                <i class="bi bi-eye" style={{marginLeft:'-5px'}}></i>
                                            </button>
                                            <Link to="/accountant/updatevehicleaccessory"
                                                type="button"
                                                className="btn  btn-sm"
                                                title="Edit">
                                                <i className="bi bi-pencil-square" style={{marginLeft:'-5px'}}></i>
                                            </Link>
                                            <button
                                                type="button"
                                                className="btn  btn-sm"
                                                onClick={() => handleNavigate(row.vehicleno)}
                                                title="Delete">
                                                <i className="bi bi-trash3" style={{marginLeft:'-5px'}}></i>
                                            </button>
                                        </div>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>




    );
}
